import React from "react";
import FormControlLabel from "@mui/material/FormControlLabel";
import useStyles from "./styles";

import CheckboxMN, {
	CheckboxProps as CheckboxPropsMN
} from "@mui/material/Checkbox";

import ls from "../../Localization";

interface CheckboxProps extends Omit<CheckboxPropsMN, "onChange"> {
	id: string;
	name: string;
	onChange(id: string, value: boolean): void;
	hideLabel?: boolean;
}

const ls2: any = ls;

function Checkbox(props: CheckboxProps) {
	const classes = useStyles({});

	const { id, name, checked, onChange, hideLabel } = props;

	return (
		<FormControlLabel
			control={
				<CheckboxMN
					classes={classes}
					checked={checked}
					onChange={e => onChange(id, e.target.checked)}
					value={name}
				/>
			}
			label={hideLabel ? undefined : ls2[name] || name}
		/>
	);
}

export default Checkbox;
